import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDynamicPhoneFlow } from 'shared/hooks/useDynamicPhoneFlow';
import { getActualPhones } from 'shared/selectors';
import { formatNumber } from 'shared/utils/phone';
import { v4 as uuid } from 'uuid';

interface IGalleryDynamicPhoneProps {
  offerId: number;
  buttonText: string;
  openPhoneClassName?: string;
  /** Событие расхлопа; clickId связывает его с запросом подменного номера */
  onOpen(clickId: string): void;
  onDegradation(clickId: string): void;
}

/** Кнопка телефона фоторамы для динКТ вторички (SEL-998): запрос подменного номера по клику */
export const GalleryDynamicPhone: React.FC<IGalleryDynamicPhoneProps> = ({
  offerId,
  buttonText,
  openPhoneClassName,
  onOpen,
  onDegradation,
}) => {
  const [isOpen, setOpen] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const { requestPhone } = useDynamicPhoneFlow();
  const phones = useSelector(getActualPhones);

  const handleClick = async () => {
    const clickId = uuid();

    onOpen(clickId);

    setLoading(true);
    const hasPhoneToShow = await requestPhone({
      offerId,
      clickId,
      hasStaticPhones: phones.length > 0,
      onDegradation: () => onDegradation(clickId),
    });
    setLoading(false);

    if (hasPhoneToShow) {
      setOpen(true);
    }
  };

  if (isOpen) {
    return <span className={openPhoneClassName}>{phones.map(formatNumber).join(', ')}</span>;
  }

  return (
    <Button size="XS" onClick={handleClick} loading={isLoading}>
      {buttonText}
    </Button>
  );
};
